import { useTranslate } from "ra-core";

import { Badge } from "@/components/ui/badge";

import type { TaskStatus } from "../../types";

const VARIANTS: Record<
  TaskStatus,
  "outline" | "secondary" | "default" | "destructive"
> = {
  todo: "outline",
  doing: "secondary",
  blocked: "destructive",
  done: "default",
};

export const TaskStatusBadge = ({ status }: { status: TaskStatus }) => {
  const translate = useTranslate();
  return (
    <Badge variant={VARIANTS[status]}>
      {translate(`crm.operations.tasks.statuses.${status}`)}
    </Badge>
  );
};
